import React, { useEffect, useState } from 'react'
import ProfilePhoto from '../../../Profile/UserDetails/ProfilePhoto'
import BasicDetails from './BasicDetails';
import AssignedTo from './AssignedTo';
import PostalAddress from './PostalAddress';
import Communications from './Communications';
import OnlinePresence from './OnlinePresence';
import { connect } from 'react-redux';
import { RootState } from '../../../../redux/rootReducers';
import { GetAllFinacUserPayloadType } from '../../../../commonTypes/authTypes';
import { getAllFinacManagerAction, getAllFinacPartnerAction, getAllFinacUsersAction, resetFinacClientUsersList } from '../../../../redux/auth';
import useDebounce from '../../../../customHooks/useDebounce';
import { CircularAvatar } from '../../../commons';
import { components } from 'react-select';
import { getAllCityAction, getAllCountryAction, getAllMasterDataBranchAction, getAllMasterDataCurrencyAction, getAllStateAction, getMasterDataBranchAction, getMasterDataClientCategoryAction, getMasterDataClientGroupAction, getMasterDataScopeOfWorkAction, resetCityList, resetStateList, resetStateListTotalCount } from '../../../../redux/masterData';
import { GetAllMasterDataBranchPayloadType, GetAllMasterDataCurrencyPayloadType, GetCityListDataPayloadType, GetClientCategoryPayloadType, GetClientGroupDataPayloadType, GetCountryListDataPayloadType, GetStateListDataPayloadType, GetUsersDepartmentPayloadType } from '../../../../commonTypes/masterDataTypes';
import { ClientBasicDetailsType } from '../../../../commonTypes/clientDirectoryTypes';
import { InputDetailsErrorType } from '..';
import { CityListTypes, ClientCategoryListType, CountryListTypes, ScopeOfWorkListType, StateListTypes } from '../../../../redux/masterData/masterTypes';
import { SelctOptionType } from '../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm';
import { LoginResponseType } from '../../../../redux/auth/authTypes';
import Select from "react-select";

type AppProps = {
  token: string | null;
  finacUser: any;
  success: number | null;
  statusCode: number | null;
  masterDataSuccess: number | null;
  masterDataStatusCode: number | null;
  userFetching: boolean;
  isEdit: boolean;
  branchFetching: boolean;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  inputDetailsError: InputDetailsErrorType;
  setInputDetailsError: (data: any) => void;
  clientBasicDetails: ClientBasicDetailsType;
  setClientBasicDetails: (data: any) => void;
  singleClientDirectory: any;
  branchDataList: any;
  finacManagerList: any;
  finacPartnerList: any;
  managerFetching: boolean;
  partnerFetching: boolean;
  masterDataCurrencyListing: [] | any[];
  masterDataCurrencyListTotal: string | number;
  masterDataBranchListTotal: string | number;
  totalPartnerCount: string | number;
  totalManagerCount: string | number;
  clientGroupList: any;
  clientGroupTotalCount: number;
  handleGoBack: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacPartnerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllMasterDataCurrencyList: (data: GetAllMasterDataCurrencyPayloadType) => void;
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => void;
  handleClientDirectoryFormSubmit: () => void;
  dispatchResetFinacClientUsersList: () => void;
  dispatchGetMasterDataClientGroup: (data: GetClientGroupDataPayloadType) => void;
  dispatchGetCountryListAction:(data:GetCountryListDataPayloadType)=>void;
  dispatchGetAllStateAction:(data:GetStateListDataPayloadType)=>void;
  dispatchResetStateListTotalCount:()=>void;
  dispatchResetStateList:()=>void;
  dispatchResetCityList:()=>void;
  dispatchGetAllCityAction:(data:GetCityListDataPayloadType)=>void;
  dispatchGetMasterDataClientCategoryAction:(data:GetClientCategoryPayloadType)=>void;
  isDisabled?: boolean;
  isViewClientPresent?:boolean
  countryList: CountryListTypes[]|[];
  countryListTotalCount: number;
  countryFetching:boolean;
  stateList:StateListTypes[]|[]
  stateListTotalCount:number;
  stateFetching:boolean
  isState: null | boolean;
  isCity: null | boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  cityFetching: boolean;
  clientCategory:SelctOptionType[]|[];
  setClientCategory:React.Dispatch<React.SetStateAction<SelctOptionType[]>>;
  setSelectedClientCategory:React.Dispatch<React.SetStateAction<number[]>>;
  selectedClientCategory:number[]|[];
  clientCategoryList: ClientCategoryListType[] | [];
  clientCategoryTotalCount: number;
  loginData: LoginResponseType;
  fetching:boolean;
  scopeOfWork:SelctOptionType[];
  setScopeOfWork:React.Dispatch<React.SetStateAction<SelctOptionType[]>>;
  selectedScopeOfWork:number[] | [];
  setSelectedScopeOfWork:React.Dispatch<React.SetStateAction<number[]>>;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  scopeOfWorkTotalCount: number;
  dispatchGetMasterDataScopeOfWorkAction:(data:GetUsersDepartmentPayloadType)=>void;



}
const ClientBasicDetails = ({
  token,
  success,
  statusCode,
  masterDataSuccess,
  masterDataStatusCode,
  finacUser,
  isEdit,
  clientCategory,
  setClientCategory,
  setSelectedClientCategory,
  selectedClientCategory,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  dispatchGetAllFinacManagerAction,
  dispatchGetAllFinacUsersAction,
  dispatchGetAllFinacPartnerAction,
  clientBasicDetails,
  setClientBasicDetails,
  handleClientDirectoryFormSubmit,
  handleGoBack,
  singleClientDirectory,
  dispatchGetAllMasterDataBranchListAction,
  dispatchGetMasterDataClientCategoryAction,
  branchDataList,
  dispatchGetAllMasterDataCurrencyList,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchResetStateListTotalCount,
  dispatchResetStateList,
  dispatchGetAllCityAction,
  dispatchResetCityList,
  masterDataCurrencyListing,
  masterDataBranchListTotal,
  masterDataCurrencyListTotal,
  userFetching,
  branchFetching,
  dispatchResetFinacClientUsersList,
  inputDetailsError,
  setInputDetailsError,
  finacManagerList,
  finacPartnerList,
  totalManagerCount,
  totalPartnerCount,
  partnerFetching,
  managerFetching,
  clientGroupList,
  clientGroupTotalCount,
  dispatchGetMasterDataClientGroup,
  isDisabled,
  isViewClientPresent,
  countryList,
  countryFetching,
  countryListTotalCount,
  stateList,
  stateListTotalCount,
  stateFetching,
  isState,
  isCity,
  cityList,
  cityListTotalCount,
  cityFetching,
  clientCategoryList,
  clientCategoryTotalCount,
  loginData,
  fetching,
  scopeOfWork,
  setScopeOfWork,
  selectedScopeOfWork,
  setSelectedScopeOfWork,
  scopeOfWorkList,
scopeOfWorkTotalCount,
  dispatchGetMasterDataScopeOfWorkAction
}: AppProps) => {
  const [accessToOthersText, setAccessToOthersText] = useState<string>("");
  const checkBottom = (e: any) => {
    setScopeOfWorkOffset((prv: any) => prv + scopeOfWorkLimit);
  };
  const [branchText, setBranchText] = useState<string>("");
  const [clientGroupText, setClientGroupText] = useState<string>("");
  const [currencyText, setCurrencyText] = useState<string>("");
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [clientGroupLimit, setClientGroupLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [clientGroupOffset, setClientGroupOffset] = useState<number>(0);
  const [option, setOption] = useState([])
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [finalClientGroupDataList, setFinalClientGroupDataList] = useState<any>([]);
  const [finalCurrencyDataList, setFinalCurrencyDataList] = useState<any>([]);
  const [finalPartnerList, setFinalPartnerList] = useState<any>([])
  const [partnerText, setPartnerText] = useState<string>("");
  const [partnerLimit, setPartnerLimit] = useState<number>(20);
  const [partnerOffset, setPartnerOffset] = useState<number>(0);
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [profileForm, setProfileForm] = useState({
    user_details: {
      basic_details: {
        first_name: "",
        last_name: ""
      },
      profile_pic: null,
    }
  })
   // country
   const [loadCondition, setLoadCondition] = useState(true);
   const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
   const [countryOffset , setCountryOffset] = useState<number>(0)
   const [countryLimit , setCountryLimit] = useState<number>(20)
   const [countryText, setCountryText] = useState<string>("");
   // state
   const [finalStateList  , setFinalStateList] = useState<any>([])
   const [stateOffset , setStateOffset] = useState<number>(0)
   const [stateLimit , setStateLimit] = useState<number>(20)
   const [stateText, setStateText] = useState<string>("");
   const [isApiCall, setIsApiCall] = useState(false);
   const [isApiCityCall, setIsApiCityCall] = useState(false);
  //  city
  const [cityOffset, setCityOffset] = useState<number>(0);
  const [cityText, setCityText] = useState<string>("");
  const [finalCityList, setFinalCityList] = useState<any>([]);
  const [cityLimit , setCityLimit] = useState<number>(20)
  const [categoryOffset , setCategoryOffset] = useState<number>(0)
  const [categoryLimit , setCategoryLimit] = useState<number>(20)
  const [searchValue , setSearchValue] = useState("")
  const [categoryText , setCategoryText] = useState("")
  const [finalCategoryList , setFinalCategoryList] = useState<any>([])
  const [finalScopeOfWorkList , setFinalScopeOfWorkList] = useState<any>([])
  const [scopeOfWorkOffset , setScopeOfWorkOffset] = useState<number>(0)
  const [scopeOfWorkLimit , setScopeOfWorkLimit] = useState<number>(20)
  const [scopeOfWorkText , setScopeOfWorkText] = useState("")

  useEffect(() => {
    dispatchResetFinacClientUsersList()
    setProfileForm((prev: any) => {
      return {
        ...prev,
        user_details: {
          basic_details: {
            first_name: singleClientDirectory?.user_details?.basic_details?.first_name,
            last_name: singleClientDirectory?.user_details?.basic_details?.last_name,
          },
          profile_pic: singleClientDirectory?.user_details?.profile_pic
        }
      }
    })
  }, [])

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""}%${user?.job_title ? user?.job_title : ""} ${user?.department ? "|" : ""} ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url
      };
    })
    if (offset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser])

  useEffect(() => {
    const branchData = branchDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.branch_name
      }
    })
    if (offset > 0) {
      setFinalBranchDataList([...finalBranchDataList, ...branchData]);
    } else {
      setFinalBranchDataList(branchData);
    }
  }, [branchDataList])

  useEffect(() => {
    const clientGroupData = clientGroupList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.client_group_name
      }
    })
    if (clientGroupOffset > 0) {
      setFinalClientGroupDataList([...finalClientGroupDataList, ...clientGroupData]);
    } else {
      setFinalClientGroupDataList(clientGroupData);
    }
  }, [clientGroupList])

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        search_term: text,
        branch_status:1
      };
      if (offset <= +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalUserData)
      }
    }
  }, [offset])

  // scope of work
  useEffect(() => {
    const finalScopeOfWorkData = scopeOfWorkList?.map((scope: any) => {
      
      return {
        value: scope?._id,
        label: scope?.scope_of_work_name,
      };
    })
    if (scopeOfWorkOffset > 0) {
      setFinalScopeOfWorkList([...finalScopeOfWorkList, ...finalScopeOfWorkData]);
    } else {
      setFinalScopeOfWorkList(finalScopeOfWorkData);
    }
  }, [scopeOfWorkList])
  useEffect(() => {
    if (token) {
      let finalUserData = {
      token,
      limit:scopeOfWorkLimit,
      offset:scopeOfWorkOffset,
      searchValue: scopeOfWorkText,
      status:1
      };
      if (scopeOfWorkOffset <= scopeOfWorkTotalCount) {
        dispatchGetMasterDataScopeOfWorkAction(finalUserData)
      }
    }
  }, [scopeOfWorkOffset])
  
  const fetchNewscopeData = (search: string) => {
    const finalData = {
      token,
      limit:scopeOfWorkLimit,
      offset:scopeOfWorkOffset,
      searchValue: scopeOfWorkText,
      status:1
    }
    dispatchGetMasterDataScopeOfWorkAction(finalData)
  }
  
  useDebounce(() => {
    if (scopeOfWorkText) {
      fetchNewscopeData(scopeOfWorkText)
    }
    else {
      const finalData = {
        token,
        limit:scopeOfWorkLimit,
        offset:scopeOfWorkOffset,
        searchValue: scopeOfWorkText,
        status:1
      }
      dispatchGetMasterDataScopeOfWorkAction(finalData)
    }
  }, 500, [scopeOfWorkText]);
  // 

  // client group offset change
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: clientGroupOffset,
        limit: clientGroupLimit,
        searchValue: clientGroupText,
      };
      if (clientGroupOffset <= +clientGroupTotalCount) {
        dispatchGetMasterDataClientGroup(finalUserData)
      }
    }
  }, [clientGroupOffset])

  useEffect(() => {
    const currencyData = masterDataCurrencyListing?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.currency_name,
        currencyDetails: {
          currencyName: data?.currency_name,
          currencyShortForm: data?.currency_short_form,
          currencySign: data?.currency_sign,
          currencyId: data?._id
        }
      }
    })
    if (offset > 0) {
      setFinalCurrencyDataList([...finalCurrencyDataList, ...currencyData]);
    } else {
      setFinalCurrencyDataList(currencyData);
    }
  }, [masterDataCurrencyListing])

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        searchTerm: text,
      };
      if (offset <= +masterDataCurrencyListTotal) {
        dispatchGetAllMasterDataCurrencyList(finalUserData)
      }
    }
  }, [offset])

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: 'stco_users',
        status: 1,
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData)
      }
    }
  }, [offset])

  //Finac Partner List
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: partnerOffset,
        limit: partnerLimit,
        user_type: 'partner',
        status: 1,
        search_term: partnerText,
      };
      if (partnerOffset <= +totalPartnerCount) {
        dispatchGetAllFinacPartnerAction(finalUserData)
      }
    }
  }, [partnerOffset])

  useEffect(() => {
    const finalPartnerData = finacPartnerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
        image: user?.profile_pic?.file_url
      };
    })
    if (partnerOffset > 0) {
      setFinalPartnerList([...finalPartnerList, ...finalPartnerData]);
    } else {
      setFinalPartnerList(finalPartnerData);
    }
  }, [finacPartnerList])

// client category 

useEffect(() => {
  const finalData = {
    token,
    limit:categoryLimit,
    offset:categoryOffset,
    search_term: categoryText,
    status:1
  }
  dispatchGetMasterDataClientCategoryAction(finalData)
}, [])


useEffect(() => {
  const finalCategoryData = clientCategoryList?.map((user: any) => {
    
    return {
      value: user?._id,
      label: user?.name_of_category,
    };
  })
  if (categoryOffset > 0) {
    setFinalCategoryList([...finalCategoryList, ...finalCategoryData]);
  } else {
    setFinalCategoryList(finalCategoryData);
  }
}, [clientCategoryList])

useEffect(() => {
  if (token) {
    let finalUserData = {
    token,
    limit:categoryLimit,
    offset:categoryOffset,
    search_term: categoryText,
    status:1
    };
    if (categoryOffset <= clientCategoryTotalCount) {
      dispatchGetMasterDataClientCategoryAction(finalUserData)
    }
  }
}, [categoryOffset])

const fetchNewCategoryData = (search: string) => {
  const finalData = {
    token,
    limit:categoryLimit,
    offset:categoryOffset,
    search_term: categoryText,
    status:1
  }
  dispatchGetMasterDataClientCategoryAction(finalData)
}

useDebounce(() => {
  if (categoryText) {
    fetchNewCategoryData(categoryText)
  }
  else {
    const finalData = {
      token,
    limit:categoryLimit,
    offset:categoryOffset,
    search_term: categoryText,
    status:1
    }
    dispatchGetMasterDataClientCategoryAction(finalData)
  }
}, 500, [categoryText]);


const handleClientCategoryChange = (e: any) => {
  let clientCategoryIdName: any = e?.map((e: any) => {
    return e?.value;
  });
  let totalUser = e?.map((e: any) => {
    return {
      value: e?.value,
      label: e?.label,
    };
  });
  setClientCategory(totalUser);

  setSelectedClientCategory(clientCategoryIdName);
};

  //Client Group search
  const fetchNewClientGroupData = (search: string) => {
    let finalUserData = {
      token,
      offset: clientGroupOffset,
      limit: clientGroupLimit,
      searchValue: clientGroupText,
    };
    dispatchGetMasterDataClientGroup(finalUserData)

  }

  useDebounce(() => {
    if (clientGroupText) {
      fetchNewClientGroupData(clientGroupText)
    }
    else {
      let finalUserData = {
        token,
        offset: clientGroupOffset,
        limit: clientGroupLimit,
        searchValue: clientGroupText,
      };
      dispatchGetMasterDataClientGroup(finalUserData)
    }
  }, 500, [clientGroupText]);

  //partner search
  const fetchNewPartnerData = (search: string) => {
    const finalData = {
      token,
      offset: partnerOffset,
      limit: partnerLimit,
      user_type: 'partner',
      status: 1,
      search_term: partnerText,
    }
    dispatchGetAllFinacPartnerAction(finalData)
  }

  useDebounce(() => {
    if (partnerText) {
      fetchNewPartnerData(partnerText)
    }
    else {
      const finalData = {
        token,
        offset: partnerOffset,
        limit: partnerLimit,
        user_type: 'partner',
        status: 1,
        search_term: partnerText,
      }
      dispatchGetAllFinacPartnerAction(finalData)
    }
  }, 500, [partnerText]);

  //finacManager
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: 'manager',
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData)
      }
    }
  }, [managerOffset])

  useEffect(() => {
    const finalManagerData = finacManagerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""}%${user?.job_title ? user?.job_title : ""} ${user?.department ? "|" : ""} ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url
      };
    })
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList])

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: 'manager',
      status: 1,
      search_term: managerText,
    }
    dispatchGetAllFinacManagerAction(finalData)
  }

  useDebounce(() => {
    if (managerText) {
      fetchNewManagerData(managerText)
    }
    else {
      const finalData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: 'manager',
        status: 1,
        search_term: managerText,
      }
      dispatchGetAllFinacManagerAction(finalData)
    }
  }, 500, [managerText]);

  useEffect(() => {
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          profilePic: profileForm?.user_details?.profile_pic ? profileForm?.user_details?.profile_pic : null
        }
      }
    })
  }, [profileForm?.user_details?.profile_pic])

  // country 
  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (countryOffset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
  }, [countryList]);

  useEffect(() => {
    dispatchResetCityList();
    dispatchResetStateList();
    if (token) {
      let finalCountryData = {
        token,
        offset:countryOffset,
          limit:countryLimit,
          search_term: countryText,
      };
      if (countryOffset <= countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
  }, [countryOffset]);

  const fetchNewCountryData = (search: string) => {
    const finalData = {
      token,
      offset:countryOffset,
      limit:countryLimit,
      search_term: countryText,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (countryText) {
        fetchNewCountryData(countryText);
      } else {
        const finalData = {
          token,
          offset:countryOffset,
          limit:countryLimit,
          search_term: countryText,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [countryText]
  );

  const handleChangeCountry = (data: any) => {
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        postalAddress: {
          ...prev.postalAddress,
          country: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })

    if (data?.value && inputDetailsError.countryError) {
      setInputDetailsError((prev: any) => {
        return {
            ...prev,
            countryError: ""
        }
    })
    }
    setInputDetailsError((prev: any) => {
      return {
          ...prev,
          stateError: ""
      }
  })
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

// 
// state
useEffect(() => {
  dispatchResetCityList();
  if (clientBasicDetails?.postalAddress?.country?.value) {
    let finalData: GetStateListDataPayloadType = {
      token,
      limit:stateLimit,
      offset: stateOffset,
      search_term: stateText,
      country_id: clientBasicDetails?.postalAddress?.country?.value,
    };

    if (stateOffset === 0) {
      dispatchGetAllStateAction(finalData);

      setIsApiCall(true);
    } else {
      dispatchGetAllStateAction(finalData);
      setStateOffset(0);
      setIsApiCall(true);
    }
  }
}, [clientBasicDetails?.postalAddress?.country?.value]);

useEffect(() => {
  dispatchResetCityList();
  if (isState === false && !stateFetching && clientBasicDetails?.postalAddress?.country?.value) {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit:cityLimit,
      offset: cityOffset,
      search_term: cityText,
      country_id: clientBasicDetails?.postalAddress?.country?.value,
    };
    if (cityOffset === 0) {
      dispatchGetAllCityAction(finalData);
    } else {
      setCityOffset(0);
    }
  }
}, [isState]);

useEffect(() => {
  const finalStateData = stateList?.map((data: any) => {
    return {
      value: data?.id,
      label: data?.name,
    };
  });
  if (stateOffset > 0) {
    setFinalStateList([...finalStateList, ...finalStateData]);
  } else {
    setFinalStateList(finalStateData);
  }
}, [stateList]);

useEffect(() => {
  dispatchResetCityList();
  if (token && stateOffset != 0) {
    let finalStateData = {
      token,
      offset: stateOffset,
      limit:stateLimit,
      search_term: stateText,
      country_id: clientBasicDetails?.postalAddress?.country?.value,
    };
    if (stateOffset <= stateListTotalCount) {
      dispatchGetAllStateAction(finalStateData);
    }
  }
}, [stateOffset]);

const fetchData = (search: string) => {
  const finalData = {
    token,
    offset: stateOffset,
    limit:stateLimit,
    search_term: stateText,
    country_id: clientBasicDetails?.postalAddress?.country?.value,
  };

  dispatchGetAllStateAction(finalData);
};

useDebounce(
  () => {
    if (stateText && isApiCall) {
      fetchData(stateText);
    } else if (isApiCall) {
      const finalData = {
        token,
        offset: stateOffset,
        limit:stateLimit,
        search_term: stateText,
        country_id: clientBasicDetails?.postalAddress?.country?.value,
      };
      dispatchGetAllStateAction(finalData);
    }
  },
  500,
  [stateText]
);

const handleChangeState = (data: any) => {
  setClientBasicDetails((prev: any) => {
    return {
      ...prev,
      postalAddress: {
        ...prev.postalAddress,
        state: {
          value: data?.value,
          label: data?.label
        }
      }
    }
  })
  if (data?.value && inputDetailsError.stateError) {
    setInputDetailsError((prevState:any) => ({
      ...prevState,
      stateError: "",
    }));
  }
  setInputDetailsError((prevState:any) => ({
    ...prevState,
    cityError: "",
  }));
};

// 
// city 
useEffect(() => {
  let finalData: GetCityListDataPayloadType = {
    token,
    limit:cityLimit,
    offset: cityOffset,
    search_term: cityText,
    state_id: clientBasicDetails?.postalAddress?.state?.value,
  };
  if (clientBasicDetails?.postalAddress?.state?.value) {
    if (cityOffset === 0) {
      dispatchGetAllCityAction(finalData);

      setIsApiCityCall(true);
    } else {
      dispatchGetAllCityAction(finalData);
      setCityOffset(0);
      setIsApiCityCall(true);
    }
  }
}, [clientBasicDetails?.postalAddress?.state?.value]);

useEffect(() => {
  const finalCityData = cityList?.map((data: any) => {
    return {
      value: data?.id,
      label: data?.name,
    };
  });
  if (cityOffset > 0) {
    setFinalCityList([...finalCityList, ...finalCityData]);
  } else {
    setFinalCityList(finalCityData);
  }
}, [cityList]);

useEffect(() => {
  if (token  && cityOffset !== 0) {
    let finalcityData = {
      token,
      offset: cityOffset,
      limit:cityLimit,
      search_term: cityText,
      state_id: clientBasicDetails?.postalAddress?.state?.value,
    };
    if (cityOffset <= cityListTotalCount) {
      dispatchGetAllCityAction(finalcityData);
    }
  }
}, [cityOffset]);

const fetchCityData = (search: string) => {
  const finalData = {
    token,
    offset: cityOffset,
    limit:cityLimit,
    search_term: cityText,
    state_id: clientBasicDetails?.postalAddress?.state?.value,
  };
  dispatchGetAllCityAction(finalData);
};

useDebounce(
  () => {
    if (cityText && isApiCityCall) {
      fetchCityData(cityText);
    } else if (isApiCityCall) {
      const finalData = {
        token,
        offset: cityOffset,
        limit:cityLimit,
        search_term: cityText,
        state_id: clientBasicDetails?.postalAddress?.state?.value,
      };
      dispatchGetAllCityAction(finalData);
    }
  },
  500,
  [cityText]
);

const handleChangeCity = (data: any) => {
  setClientBasicDetails((prev: any) => {
    return {
      ...prev,
      postalAddress: {
        ...prev.postalAddress,
        city: {
          value: data?.value,
          label: data?.label
        }
      }
    }
  })

  if (data?.value && inputDetailsError.cityError) {
    setInputDetailsError((prevState:any) => ({
      ...prevState,
      cityError: "",
    }));
  }
};

const handleScopeOfWorkChange = (e: any) => {
  let scopeOfWorkIdName: any = e?.map((e: any) => {
    return e?.value;
  });
  let totalUser = e?.map((e: any) => {
    return {
      value: e?.value,
      label: e?.label,
    };
  });
  setScopeOfWork(totalUser);

  setSelectedScopeOfWork(scopeOfWorkIdName);
};
// 
  const handleAssignedDropdownChange = (e: any, name: string) => {
    setClientBasicDetails((prev: any) => {
      switch (name) {
        case "partner":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              partner: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
          case "seniorManager":
            return {
              ...prev,
              assignedTo: {
                ...prev.assignedTo,
                seniorManager: {
                  value: e.value,
                  label: e?.label?.split("%")[0]
                }
              }
            }
        case "manager":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              manager: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
        case "accountingInCharge":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              accountingInCharge: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
        case "taxInCharge":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              taxInCharge: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
        case "auditInCharge":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              auditInCharge: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
        case "hrInCharge":
          return {
            ...prev,
            assignedTo: {
              ...prev.assignedTo,
              hrInCharge: {
                value: e.value,
                label: e?.label?.split("%")[0]
              }
            }
          }
        default:
          return;
      }
    })
  }

  const handleClientGroupDetailsChange = (data: any) => {
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        assignedTo: {
          ...prev.assignedTo,
          clientGroup: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }

  const handleBranceDetailsChange = (data: any) => {
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        assignedTo: {
          ...prev.assignedTo,
          branch: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const handleCurrencyDetailsChange = (data: any) => {
    if (data?.value) {
      setInputDetailsError((prev: any) => {
          return {
              ...prev,
              currencyError: ""
          }
      })
  }
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        assignedTo: {
          ...prev.assignedTo,
          currency: {
            value: data?.value,
            label: data?.label,
            currencyDetails: {
              currencyName: data?.currencyDetails?.currencyName,
              currencyShortForm: data?.currencyDetails?.currencyShortForm,
              currencySign: data?.currencyDetails?.currencySign,
              currencyId: data?.currencyDetails?.currencyId
            }
          }
        }
      }
    })
  }

  const handleEntityChange = (data: any) => {
    setInputDetailsError((prev: any) => {
      return {
        ...prev,
        entityError: ""
      }
    })
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          entity: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const handleContactTypeChange = (data: any) => {
    if ((clientBasicDetails?.basicDetails?.entity?.value !== "Individual" && clientBasicDetails?.basicDetails?.entity?.value !== "Sole Proprietorship") && clientBasicDetails?.basicDetails?.name) {
      setInputDetailsError((prev: any) => {
        return {
          ...prev,
          companyNameError: ""
        }
      })
    }
    setClientBasicDetails((prev: any) => {
      return {
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          contactType: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: 'stco_users',
      status: 1,
      search_term: text,
    }
    dispatchGetAllFinacUsersAction(finalData)
  }

  useDebounce(() => {
    if (text) {
      fetchNewData(text)
    }
    else {
      const finalData = {
        token,
        offset,
        limit,
        user_type: 'stco_users',
        status: 1,
        search_term: text,
      }
      dispatchGetAllFinacUsersAction(finalData)
    }
  }, 500, [text]);

  const fetchNewBranchData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: branchText,
      branch_status:1
    }
    dispatchGetAllMasterDataBranchListAction(finalData)
  }

  useDebounce(() => {
    if (branchText) {
      fetchNewBranchData(branchText)
    }
    else {
      const finalData = {
        token,
        offset,
        limit,
        search_term: branchText,
        branch_status:1
      }
      dispatchGetAllMasterDataBranchListAction(finalData)
    }
  }, 500, [branchText]);

  const fetchNewCurrencyData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: currencyText,
    }
    dispatchGetAllMasterDataCurrencyList(finalData)
  }

  useDebounce(() => {
    if (currencyText) {
      fetchNewCurrencyData(currencyText)
    }
    else {
      const finalData = {
        token,
        offset,
        limit,
        search_term: currencyText,
      }
      dispatchGetAllMasterDataCurrencyList(finalData)
    }
  }, 500, [currencyText]);
  return (
    <div className='card'>
      <h5>Basic Details</h5>
      <span className='mb-3'>Update client logo and contact details here</span>
      <ProfilePhoto
        data={singleClientDirectory?.user_details}
        setProfileForm={setProfileForm}
        isEdit={false}
      />
      <h4 className='mt-3'>BASIC DETAILS</h4>
      <BasicDetails
        isEdit={isEdit}
        handleEntityChange={handleEntityChange}
        handleContactTypeChange={handleContactTypeChange}
        basicDetails={clientBasicDetails?.basicDetails}
        setClientBasicDetails={setClientBasicDetails}
        inputDetailsError={inputDetailsError}
        setInputDetailsError={setInputDetailsError}
        isDisabled={isDisabled}
        clientCategory={clientCategory}
        // setClientCategory={setClientCategory}
        // setSelectedClientCategory={setSelectedClientCategory}
        // selectedClientCategory={selectedClientCategory}
        finalCategoryList={finalCategoryList}
        handleClientCategoryChange={handleClientCategoryChange}
        setCategoryOffset = {setCategoryOffset}
        setCategoryText = {setCategoryText}
        loginData={loginData}
        fetching={fetching}
        categoryLimit={categoryLimit}

      />
      <h4 className='mt-3'>ASSIGNED TO</h4>
      <AssignedTo
        setClientGroupOffset={setClientGroupOffset}
        setoffset={setoffset}
        limit={limit}
        clientGroupLimit={clientGroupLimit}
        text={text}
        userFetching={userFetching}
        branchText={branchText}
        clientGroupText={clientGroupText}
        setClientGroupText={setClientGroupText}
        currencyText={currencyText}
        branchFetching={branchFetching}
        setText={setText}
        setBranchText={setBranchText}
        setCurrencyText={setCurrencyText}
        finalUserList={finalUserList}
        finalClientGroupDataList={finalClientGroupDataList}
        finalBranchDataList={finalBranchDataList}
        currencyData={finalCurrencyDataList}
        handleBranceDetailsChange={handleBranceDetailsChange}
        handleClientGroupDetailsChange={handleClientGroupDetailsChange}
        handleCurrencyDetailsChange={handleCurrencyDetailsChange}
        assignedDropDownValue={clientBasicDetails?.assignedTo}
        handleAssignedDropdownChange={handleAssignedDropdownChange}
        finalManagerList={finalManagerList}
        finalPartnerList={finalPartnerList}
        setManagerOffset={setManagerOffset}
        setManagerText={setManagerText}
        partnerText={partnerText}
        managerText={managerText}
        partnerFetching={partnerFetching}
        setPartnerText={setPartnerText}
        managerFetching={managerFetching}
        setPartnerOffset={setPartnerOffset}
        partnerLimit={partnerLimit}
        managerLimit={managerLimit}
        isDisabled={isDisabled}
        inputDetailsError={inputDetailsError}
        isEdit={isEdit}
      />
      <h4 className='mt-3'>POSTAL ADDRESS</h4>
      <PostalAddress
        setClientBasicDetails={setClientBasicDetails}
        postalAddress={clientBasicDetails?.postalAddress}
        inputDetailsError={inputDetailsError}
        setInputDetailsError={setInputDetailsError}
        isDisabled={isDisabled}
        onMenuClose={onMenuClose}
        Option={Option}
        countrySelectedList={countrySelectedList}
        countryFetching={countryFetching}
        setLoadCondition ={setLoadCondition}
        setCountryText={setCountryText}
        setCountryOffset={setCountryOffset}
        handleChangeCountry={handleChangeCountry}
        countryLimit={countryLimit}
        postalAddressDropDownValue={clientBasicDetails?.postalAddress}
        handleChangeState={handleChangeState}
        finalStateList={finalStateList}
        stateFetching={stateFetching}
        setStateOffset={setStateOffset}
        setStateText={setStateText}
        isState={isState}
        isCity={isCity}
        finalCityList={finalCityList}
        handleChangeCity={handleChangeCity}
        setCityOffset={setCityOffset}
        setCityText={setCityText}
        cityLimit={cityLimit}
        setCityLimit={setCityLimit}
        stateLimit={stateLimit}


        // postalAddressStateValue={clientBasicDetails?.postalAddress}



      />
      <h4 className='mt-3'>COMMUNICATIONS</h4>
      <Communications
        setClientBasicDetails={setClientBasicDetails}
        communication={clientBasicDetails?.communication}
        inputDetailsError={inputDetailsError}
        setInputDetailsError={setInputDetailsError}
        isDisabled={isDisabled}
      />
      <h4 className='mt-3'>ONLINE PRESENCE</h4>
      <OnlinePresence
        setClientBasicDetails={setClientBasicDetails}
        onlinePresence={clientBasicDetails?.onlinePresence}
        isDisabled={isDisabled}
      />
      { isDisabled ?
      <>
      {/* <h4 className='mt-3'>SCOPE OF WORK DETAILS</h4>
      <div className='row mb-5'>

        <div className='col-md-3'>
        <label htmlFor="skype"></label>
                <div >
                    <input
                        type="text"
                        className={`form-control`}
                        name="skype"
                        // onChange={handleonlinePresenceDetailsChange}
                        value={singleClientDirectory?.lead_info_details?.scope_of_work_details?.scope_of_work?.scope_of_work}
                        // disabled={isDisabled}
                    />
                </div>
        </div>

      </div> */}
       <p style={{ fontWeight: "500",marginBottom:'0px' }}>
        SCOPE OF WORK DETAILS
      </p>
      <div className="row">
        <div className="col-md-3">
          <label>Scope of Work</label>
          <Select
            className="dropdown"
            placeholder={
              <div style={{ color: "hsl(0, 0%, 20%)" }}>Select..</div>
            }
            value={
              scopeOfWork[0]?.label
                ? scopeOfWork?.filter(
                    (e: any) => e?.value !== loginData?.user_id
                  )
                : []
            }
            options={finalScopeOfWorkList}
            onChange={handleScopeOfWorkChange}
            isMulti
            isClearable
            isLoading={fetching && accessToOthersText?.length > 0}
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e: string) => {
              setScopeOfWorkText(e);
              setAccessToOthersText(e);
              setScopeOfWorkOffset(0);
            }}
            isDisabled={isDisabled}

          />
        </div>
      </div>
      </>
:''}

      <hr></hr>
      <div className='row'>
        <div className='col-md-12 text-right'>
          <button
            className={isViewClientPresent?"btn-primary btn":"btn" }
            style={{ border: "1px solid #bfcbe1", marginRight: '15px' }}
            onClick={() => handleGoBack()}
          >
            {isViewClientPresent ? "Back" : "Cancel"}
          </button>
          {!isViewClientPresent?<button
            className='btn btn-primary'
            disabled={clientPanUniqueCheckMessage?.includes("PAN number already exists") || clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists")}
            onClick={handleClientDirectoryFormSubmit}
          >
            {isEdit ? "Save Changes" : "Save"}
          </button>:""}
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.auth.success,
  statusCode: state.auth.statusCode,
  masterDataSuccess: state.masterData.success,
  masterDataStatusCode: state.masterData.statusCode,
  finacUser: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataCurrencyListing:
    state.masterData.masterDataCurrencyListing,
  masterDataCurrencyListTotal:
    state.masterData.masterDataCurrencyListTotal,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  partnerFetching: state.auth.partnerFetching,
  managerFetching: state.auth.managerFetching,
  finacManagerList: state.auth.finacManagerList,
  finacPartnerList: state.auth.finacPartnerList,
  totalPartnerCount: state.auth.totalPartnerCount,
  totalManagerCount: state.auth.totalManagerCount,
  clientGroupList: state.masterData.clientGroupList,
  clientGroupTotalCount: state.masterData.clientGroupTotalCount,
  countryList: state.masterData.countryList,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryFetching:state.masterData.countryFetching,
  stateList:state.masterData.stateList,
  stateListTotalCount:state.masterData.stateListTotalCount,
  stateFetching:state.masterData.stateFetching,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  cityList: state.masterData.cityList,
  cityListTotalCount: state.masterData.cityListTotalCount,
  cityFetching: state.masterData.cityFetching,
  clientCategoryList: state.masterData.clientCategoryList,
  clientCategoryTotalCount: state.masterData.clientCategoryTotalCount,
  loginData: state.auth.loginData,
  fetching: state.masterData.fetching,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,

})
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacManagerAction(data)),
  dispatchGetAllFinacPartnerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacPartnerAction(data)),
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  dispatchGetAllMasterDataCurrencyList: (
    data: GetAllMasterDataCurrencyPayloadType
  ) => dispatch(getAllMasterDataCurrencyAction(data)),
  dispatchGetMasterDataClientGroup: (data: GetClientGroupDataPayloadType) => {
    dispatch(getMasterDataClientGroupAction(data));
  },
  dispatchResetFinacClientUsersList: () => dispatch(resetFinacClientUsersList),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
  dispatch(getAllCountryAction(data)),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
  dispatch(getAllStateAction(data)),
  dispatchResetStateListTotalCount:()=> dispatch(resetStateListTotalCount()),
  dispatchResetStateList:()=> dispatch(resetStateList()),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
  dispatch(getAllCityAction(data)),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => dispatch(getMasterDataClientCategoryAction(data)),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),
})
export default connect(mapStateToProps, dispatchStateToProps)(ClientBasicDetails)